<template>
  <modal title="Notifications" ref="modal">
    <async-items-loader :task="task" :num-items="userNotifications.length">
      You have no notifications.
    </async-items-loader>
    <div class="text-right q-my-sm">
      <mark-all-read-btn :user-id="userId" @marked-read="markAllRead" />
    </div>
    <q-list>
      <user-notification-item
        v-for="userNotification in userNotifications"
        :key="userNotification.id"
        :user-notification="userNotification"
        @marked-one-read="set"
      />
    </q-list>
    <mini-pagination
      class="q-mt-md"
      :model-value="page"
      :per-page="perPage"
      :total="total"
      @update:model-value="changePage" />
  </modal>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { HasTaskMixin, ModalMixin } from '@/mixins';
import Modal from '@/components/modal/Modal.vue';
import { QueryResult, UserNotification, UserNotificationFilter } from '@/type';
import AsyncItemsLoader from '@/components/item/AsyncItemsLoader.vue';
import UserNotificationItem from '@/user-notification/UserNotificationItem.vue';
import MiniPagination from '@/components/pagination/MiniPagination.vue';
import userNotificationRepository from './user-notification-repository';
import MarkAllReadBtn from './MarkAllReadBtn.vue';

  interface Data {
    page: number,
    perPage: number,
    total: number,
    offset: number,
    userNotifications: UserNotification[],
  }

export default defineComponent({
  mixins: [HasTaskMixin, ModalMixin],
  props: {
    userId: {
      type: Number,
      required: true,
    },
  },
  data(): Data {
    return {
      page: 1,
      perPage: 5,
      total: 0,
      offset: 0,
      userNotifications: [],
    };
  },
  computed: {
    filters(): UserNotificationFilter {
      return {
        offset: this.offset,
        limit: this.perPage,
      };
    },
  },
  watch: {
    filters: {
      deep: true,
      handler(): void {
        this.load();
      },
    },
  },
  methods: {
    changePage(page: number): void {
      this.offset = (page - 1) * this.perPage;
      this.page = page;
    },
    load(): void {
      this.task = userNotificationRepository.findAll(this.userId, this.filters);
      this.task.then((result: QueryResult) => {
        this.total = result.total;
        this.userNotifications = (result.items as UserNotification[]);
      });
    },
    set(userNotification: UserNotification) {
      const index = this.userNotifications.findIndex(un => userNotification.id === un.id);
      if (index >= 0) {
        this.userNotifications.splice(index, 1, userNotification);
      }
    },
    markAllRead() {
      this.userNotifications.forEach((userNotification) => {
        userNotification.readAt = new Date().toDateString();
      });
    },
  },
  created(): void {
    this.load();
  },
  components: {
    modal: Modal,
    'async-items-loader': AsyncItemsLoader,
    'user-notification-item': UserNotificationItem,
    'mini-pagination': MiniPagination,
    MarkAllReadBtn,
  },
});
</script>
